import { bindActionCreators } from 'redux';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setStatsProfilingFilterQuestion } from 'actions';
import _ from 'i18n';
import { getTextByLanguage } from 'surveyUtils';
import { selectQuestionFilter } from 'reducers';
import ReactTooltip from 'react-tooltip';
import shortId from 'shortid';

const OPERATORS = [
  { value: 'eq', symbol: '=' },
  { value: 'lt', symbol: '<' },
  { value: 'lte', symbol: '<=' },
  { value: 'gt', symbol: '>' },
  { value: 'gte', symbol: '>=' },
];
class StepsFilter extends Component {
  constructor(props) {
    super(props);
    const { value, operator } = props;
    this.tooltipId = `tooltip-stats-${shortId.generate()}`;
    this.state = { value: value == 'all' ? '' : value, operator: operator || 'eq' };
  }

  componentDidMount() {
    const { value, operator } = this.props;
    this.setState({ value: value == 'all' ? '' : value, operator });
  }

  onChange = ({ target: { value } }) => {
    this.setState({ value });
  }

  handleOperatorChange = ({ target: { value } }) => {
    this.setState({ operator: value });
  }

  onKeyDown = (e) => {
    if (e.key == 'Enter') {
      e.preventDefault();
      this.applyFilter();
    }
  };

  applyFilter = () => {
    const { value, operator } = this.state;
    const { question: { id }, resource } = this.props;
    this.props.setStatsProfilingFilterQuestion(id, resource, 'answerValue', value, operator);
  }

  render() {
    const { text } = this.props.question;
    const { value, operator } = this.state;
    return (
      <div className="profiling-item column column-block">
        <div className="title srv-tooltip">
          <div className="greetings" data-tip data-for={this.tooltipId}>{getTextByLanguage(text, this.props.language)}</div>
          <ReactTooltip id={this.tooltipId} className="react-tooltip">
            <span className="tooltip-content">{getTextByLanguage(text, this.props.language)}</span>
          </ReactTooltip>
        </div>
        <div className="content">
          <div className="input-group">
            <input
              className="input-group-field"
              type="text"
              placeholder={`${_('search value')} ...`}
              value={value}
              onChange={this.onChange}
              onKeyDown={this.onKeyDown}
            />
            <select className="operator" value={operator} placeholder="operator" onChange={this.handleOperatorChange}>
              {OPERATORS.map(({ value, symbol }) => <option key={`country-${value}`} value={value}>{symbol}</option>)}
            </select>
            <div className="input-group-button">
              <button className="button tiny secondary" type="button" onClick={this.applyFilter}>OK</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, { question: { id } }) => {
  const filter = selectQuestionFilter(state.stats.filter, id);

  return ({
    value: filter != null ? filter.value : 'all',
    operator: filter != null ? filter.operator : 'eq',
  });
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ setStatsProfilingFilterQuestion }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StepsFilter);
